import axios from "@/api/interceptor_bjh";

/**
 * 财务管理
 * @param params 
 * @returns 
 */

// 入账记录
export function getAgentFinances(params: any) {
  return axios.get("/agent/finances", { params });
}

// 二代记录
export function getAgentFinancesAgent2Record(params: any) {
  return axios.get("/agent/finances/agent2-record", { params });
}

// 直客记录
export function getAgentFinancesClientRecord(params: any) {
  return axios.get("/agent/finances/client-record", { params });
}

// 代理充值
export function postAgentFinancesRecharge(data: any) {
  return axios.post("/agent/finances/recharge", data);
}
